import { audioService } from '@/services/audio';
import useAudioStore from '@/stores/audio';
import { useEffect } from 'react';

type Params = {
  url: string;
  loop?: boolean;
  readyToPlay?: boolean;
  delayInMs?: number;
};
export default function usePlayAudio({
  url,
  loop = false,
  readyToPlay = true,
  delayInMs = 0
}: Params) {
  const { isMuted } = useAudioStore();

  useEffect(() => {
    let timeoutId: NodeJS.Timeout | undefined;

    if (!isMuted && readyToPlay) {
      if (delayInMs) {
        timeoutId = setTimeout(() => {
          audioService.play(url, loop);
        }, delayInMs);
      } else {
        audioService.play(url, loop);
      }
    }

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      audioService.stop();
    };
  }, [isMuted, readyToPlay, url, loop, delayInMs]);
}
